import gql from "graphql-tag";

export const MY_MApp_PULSE_CHECK = gql`
  query myResiliencePulseCheck {
    myResiliencePulseCheck
  }
`;
